<ts-asset-card
  *ngIf="asset; else noLine"
  header="{{ 'my_line' | translate }}"
  [class]="class"
  [card_wrap]="card_wrap"
  [asset_fields]="['plan', 'contract_end_date', 'add_on_features']"
  [asset]="asset"
/>

<ng-template #noLine>
  <div [ngClass]="[card_wrap ? 'card shadow-sm' : '', 'mb-3']">
    <div [ngClass]="{ 'card-body': card_wrap }">
      <h4 class="mb-3">{{ 'my_line' | translate }}</h4>

      <div class="alert alert-secondary m-0 fw-normal" role="alert">
        <span>{{ 'my_line_you_have_chosen' | translate }}</span>
      </div>
    </div>
  </div>
</ng-template>
